import ParagraphHeader from 'components/ParagraphHeader';
import Button from 'components/common/Button';

import useDisclosure from 'hooks/useDisclosure';
import { BlogsProps } from 'interfaces/cms/content';
import BlogCard from './BlogCard';

function Blogs({
  header,
  blogs,
  additionalBlogs,
  seeMoreButton,
  background: backgroundColor,
}: BlogsProps) {
  const { isOpen: isShowAll, onToggle } = useDisclosure();

  return (
    <div style={{ backgroundColor }} className="py-[1.875rem]">
      <div className="max-w-[69.375rem] mx-auto px-[1rem]">
        {header && (
          <>
            <ParagraphHeader {...header} />
            <div className="mb-[1.875rem]" />
          </>
        )}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[1.875rem]">
          {blogs.map((blog) => (
            <BlogCard {...blog} key={blog.id} />
          ))}
          {isShowAll &&
            additionalBlogs?.map((blog) => (
              <BlogCard {...blog} key={blog.id} />
            ))}
        </div>

        {additionalBlogs && additionalBlogs.length > 0 && seeMoreButton && (
          <div className="text-center mx-auto w-full md:w-[31.25rem]">
            <Button
              {...seeMoreButton}
              isRowButton
              onClick={onToggle}
              buttonLabel={
                isShowAll
                  ? seeMoreButton.showLessLabel
                  : seeMoreButton.seeMoreLabel
              }
              buttonType="outline"
              buttonSize="normal"
              btnStyle="mt-[1.875rem]"
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Blogs;
